import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/planTorresConstants';
import { transformCurriculumItems } from '../../lib/PlanTorresCurriculumManager';
import { getRoundTower } from './planTorresSelectors';

const initialState = {
  // current step index
  currentStepIndex: null,
  // array with standard items
  standardItems: [],
  // array filled with target words step by step
  tower: [],
  // user's progress
  progress: 0,
  // level id
  roundLevelId: null,
};

const planTorresStandardRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_STANDARD_ROUND: {
      const { standardItems, roundLevelId } = action.payload;
      const standardItemsFinal = transformCurriculumItems(standardItems);

      return {
        ...initialState,
        standardItems: standardItemsFinal,
        roundLevelId,
        currentStepIndex: 0,
        tower: getRoundTower({
          ...state,
          standardItems: standardItemsFinal,
        }),
      };
    }
    case REDUX_ACTIONS.NEXT_STANDARD_STEP: {
      const nextStepIndex = state.currentStepIndex + 1;

      return {
        ...state,
        currentStepIndex: nextStepIndex === state.standardItems.length ? null : nextStepIndex,
      };
    }
    case REDUX_ACTIONS.DISCONTINUE_STANDARD_ROUND: {
      return {
        ...state,
        currentStepIndex: null,
      };
    }
    case REDUX_ACTIONS.BUILD_STANDARD_TOWER: {
      return {
        ...state,
        tower: getRoundTower(state),
      };
    }
    case REDUX_ACTIONS.MARK_PROGRESS: {
      // for better readability have this constant there
      // if answer was correct (true) - increment is 1, if no (false) - increment is 0
      const progressIncrement = +action.payload;

      return {
        ...state,
        progress: state.progress + progressIncrement,
      };
    }
    case REDUX_ACTIONS.QUICK_ROUND: {
      const num = state.standardItems.length;
      const numCorrect = action.payload ? num : 0;
      return {
        ...state,
        progress: numCorrect,
        currentStepIndex: null,
      };
    }
    default:
      return state;
  }
};

export default planTorresStandardRoundReducer;
